'use client';
import styled from 'styled-components';
import {
  LOT_THEME,
  ResetFieldset,
  ResetLi,
  UnstyledButton,
} from '../_Common/lot.common.styles';
import { Wink as WinkIcon } from '../_Common/Wink';

export const Container = styled.header`
  display: grid;
  grid-template-columns: min-content 1fr 1fr;
  gap: 16px;
  justify-content: space-between;

  @media screen and (width < ${LOT_THEME.breakpoints.md}) {
    grid-column: 1 / -1;
    justify-self: start;
    margin-left: 12px;
  }
`

export const ButtonGroup = styled(ResetFieldset)`
  display: flex;
  border: 0;

  gap: 8px !important;
  justify-self: end;
  color: ${LOT_THEME.graysGray};
  position: sticky;
  top: -32px;
  bottom: 0;
  right: 0;
  z-index: ${LOT_THEME.zIndex.heading};
  @media screen and (width < ${LOT_THEME.breakpoints.md}) {
    grid-column: 1 / -1;
    justify-self: start;
    margin-left: 12px;
  }
`
export const Button = styled(UnstyledButton)`
  background-color: transparent;
  /* width: min-content;
  min-width: 60px;
  max-width: 120px; */
`

export const HeaderGroup = styled.hgroup`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h4 {
    line-height: 18px;
  }
  p {
    line-height: 24px;
  }
  @media screen and (width < ${LOT_THEME.breakpoints.md}) {
    grid-column: span 2;
  }
`
export const Li = styled(ResetLi)`
  background-color: transparent;
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 24px;
  h5 {
    user-select: none;
  }
`

export const Wink = styled(WinkIcon)`
  path,
  .wink_svg__pupil {
    fill: ${LOT_THEME.graysGray};
  }
`
